<template>
  <div
    style="border: 0px solid black; width:100%;overflow: hidden;display:block;"
   v-if="has_perm('view_decentralization') || GET_ACCOUNT_DATA.id == 1"
  >
    <div
      class="welcome"
      style="border: 0px solid red;display: table; width:100%; "
    >
      <div class="box box-primary">
        <div class="box-header" style="display:block;">
          <div class="box-header border_bottom">
            <label style="font-size:18px">
              {{ $t("sidebar.decentralizationManagement.title_page") }}
            </label>
          </div>
          <div class="box-header">
            <label>{{$t("sidebar.decentralizationManagement.user_groups")}}</label>
            <div style="width: 100%">
              <lte-groupdropdown
                :item="itemGroups"
                @onchangeselect="onClickItemRow"
                style=""
              ></lte-groupdropdown>
            </div>
          </div>
        </div>
        <!-- /.box-header -->
      </div>
      <div class="box box-default">
        <div
          class="box-header"
          style="display:block;min-height:100px;border-top:3px"
        >
          <div class="module_box box-header">
            <label>{{$t("sidebar.decentralizationManagement.main_function")}}</label>
            <div class="grid_container">
              <ul>
                <li
                  style="margin-top: 5px;"
                  v-for="mdl in GET_ALLMODULES_DATA"
                  v-bind:key="mdl.id"
                >
                  <a
                    class="btn btn-sq-sm btn-primary"
                    style="width:200px"
                    @click="onPermissionClick(mdl.id)"
                    >{{ $t(`sidebar.decentralizationManagement.modules.${mdl.module_name}`) }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="box box-default">
        <div
          class="box-header"
          style="display:block;min-height:300px;border-top:3px"
        >
          <permission-list
            :data="GET_FUNCTIONPERMISSIONS_DATA"
            @permissionChange="onPermissionChange"
          ></permission-list>
          <div class="box-footer">
            <lte-button
              v-if="has_perm('create_decentralization') || has_perm('update_decentralization')"
              style="float:right;"
              type="btn btn-labeled btn-success pull-right"
              right_icon="glyphicon glyphicon-floppy-saved"
              @click="onSave"
              >{{ $t("sidebar.decentralizationManagement.saveperm") }}</lte-button
            >
          </div>
        </div>
      </div>
      <lte-core-alert
        v-for="snackbar in GET_SNACK_BAR"
        :key="snackbar.id"
        :item="snackbar"
      ></lte-core-alert>
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        color="#1E90FF"
      ></loading>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LTEButton from "@/components/LTEButton.vue";
// import LTETable from "@/components/LTETable.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Loading from "vue-loading-overlay";
import GroupPermissionsList from "@/components/GroupPermissionsList.vue";
import utils from '@/lib/utils';
import SelectOptionCustom from "@/components/SelectOptionCustom.vue";
// import LTETableCheckBox from "@/components/LTETableCheckBox.vue";

export default {
  name: "DecentralizationGroup",
  data() {
    return {
      hdBackground:
        "background-color: #4b646f;color:white;border:1px solid white;",
      boxStyle: false,
      actions: ["common.modify"],
      paginatorItem: {
        commit_function: ""
      },
      entryId: 0,
      itemGroups: {
        func_get_list: this.GET_MEMBERROLECODES,
        func_add: this.ADD_USERGROUP,
        itemType: 1,
        showLabel: false,
        modifyFromPosition: "margin-left:32px",
        cssClassSm1: "col-sm-3",
        cssClassSm2: "col-sm-4",
        showAddNew: false
      },
      currentRole: {},
      currentModule: {},
      isLoading: false
    };
  },
  methods: {
    ...mapActions([
      "PAGINATION_PREV_PAGE",
      "PAGINATION_NEXT_PAGE",
      "GET_SERVICE_LIST",
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "ADD_USERGROUP",
      "GET_MEMBERROLECODES",
      "GET_MODULES",
      "GET_ROLEPERMISSION",
      "GET_FUNCTION",
      "GET_FUNCTIONPERMISSION",
      "SAVE_PERMISSIONS",
      "SET_USER_DATA"
    ]),
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    toggleButton: function(service) {
      service.isCollapsed = !service.isCollapsed;
    },
    onPrevPagination: function() {
      const data = {
        url: this.PAGE_ARROW.prev
        // commit_funtion: "GET_USERGROUPS"
      };
      this.PAGINATION_NEXT_PAGE(data);
    },

    onNextPagination: function() {
      const data = {
        url: this.PAGE_ARROW.next
        // commit_funtion: "GET_USERGROUPS"
      };
      this.PAGINATION_NEXT_PAGE(data);
    },

    onPagination: function(value) {
      if (value === 0) return false;
      const data = {
        params: {
          page: value
        }
      };
      this.GET_SERVICE_LIST(data);
      this.GET_SERVICE_TYPE_LIST();
    },
    onClickItemRow: function(entryId) {
      this.GET_MEMBERROLECODES_DATA.forEach(item => {
        if (entryId == item.id) {
          this.currentRole = item;
        }
      });
      const filter = {
        params: {
          roleCode: this.currentRole.id
        }
      };
      this.GET_ROLEPERMISSION(filter);
    },
    onPermissionClick: function(module_id) {
      this.GET_ALLMODULES_DATA.forEach(item => {
        if (module_id == item.id) {
          this.currentModule = item;
        }
      });
      if (this.activeLink) {
        this.activeLink.classList.remove("highlight");
      }
      this.activeLink = event.target;
      this.activeLink.classList.add("highlight");
    },
    onGroupClick: function() {},
    onPermissionChange: function(data) {
      let role_permission_exist_ind = false;
      for (let i = 0; i < this.GET_ROLEPERMISSION_DATA.length; i++) {
        let item = this.GET_ROLEPERMISSION_DATA[i];
        if (
          item.functionPermissionDetails.permission_code == data.permission_code
        ) {
          item.enable = data.enabled;
          role_permission_exist_ind = true;
        }
      }
      if (role_permission_exist_ind == false) {
        let new_item = {
          functionPermissionDetails: {
            id: data.id,
            permission_name: data.permission_name,
            permission_code: data.permission_code,
            func_id: data.func_id
          },
          enable: data.enabled,
          member_role: this.currentRole.id,
          function_permission: "id" in data ? data.id : 0
        };
        this.GET_ROLEPERMISSION_DATA.push(new_item);
      }
    },
    onNewGroup: function() {},
    onSave: function() {
      let roleId = this.currentRole.id;
      let role = this.currentRole;
      let module_code = this.currentModule.id;
      let requestData = {
        role_id: roleId,
        role: role,
        module: module_code,
        data: this.GET_ROLEPERMISSION_DATA
      }
      this.isLoading = true;
      this.SAVE_PERMISSIONS(requestData)
        .then(
          function() {
            this.isLoading = false;
            this.SET_USER_DATA();
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    getFunctionPermissions: function() {
      if (this.currentModule.id != null) {
        const filter = {
          params: {
            moduleCode: this.currentModule.id,
            memberRoleCode: this.current_role_data.id
          }
        };
        this.GET_FUNCTIONPERMISSION(filter);
      }
    }
  },
  watch: {
    GET_SERVICE_DATA: function() {},
    GET_MEMBERROLECODES_DATA: function() {
      this.currentRole = this.GET_MEMBERROLECODES_DATA[0];
      const filter = {
        params: {
          roleCode: this.currentRole.id
        }
      };
      this.GET_ROLEPERMISSION(filter);
    },
    GET_CURRENT_ROLE: function() {},
    GET_ALLMODULES_DATA: function() {
      this.currentModule = this.GET_ALLMODULES_DATA[0];
      const filter = {
        params: {
          moduleCode: this.currentModule.id
        }
      };
      this.GET_FUNCTION(filter);
    },
    GET_ROLEPERMISSION_DATA: function() {},
    GET_FUNCTIONS_DATA: function() {
      this.getFunctionPermissions();
    },
    GET_FUNCTIONPERMISSIONS_DATA: function() {},
    current_role_data: function() {
      this.getFunctionPermissions();
    },
    current_module_data: function() {
      this.getFunctionPermissions();
    }
  },
  computed: {
    ...mapGetters([
      "PAGINATOR",
      "PAGE_ARROW",
      "PAGINATION",
      "GET_SNACK_BAR",
      "GET_MEMBERROLECODES_DATA",
      "GET_ALLMODULES_DATA",
      "GET_ROLEPERMISSION_DATA",
      "GET_FUNCTIONS_DATA",
      "GET_FUNCTIONPERMISSIONS_DATA",
      "GET_CURRENT_ROLE",
      "GET_ACCOUNT_DATA"
    ]),
    current_role_data: function() {
      return this.currentRole;
    },
    current_module_data: function() {
      return this.currentModule;
    }
  },
  mounted() {},
  created() {
    this.GET_MEMBERROLECODES();
    this.GET_MODULES();
  },
  components: {
    "lte-button": LTEButton,
    loading: Loading,
    "lte-core-alert": LTECoreAlert,
    "permission-list": GroupPermissionsList,
    "lte-groupdropdown": SelectOptionCustom
  }
};
</script>

<style scoped>
.fix-width {
  width: 250px;
}
.set-right {
  float: right;
}
.module_box {
  /* border: 1.5px outset rgb(165, 165, 165); */
  background-color: inherit;
  margin: 0 0 0 0;
  overflow: visible;
}
.module_box ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
}
.module_box ul li {
  float: left;
  text-transform: uppercase;
  font-weight: bolder;
  text-decoration: none;
  list-style-type: none;
  margin: 0 1.5% 0 0;
}
.grid_container {
  display: grid;
  grid-template-columns: auto auto auto auto;
}
.box_rightpane {
  width: 100%;
  margin: 0 0 0 5%;
}
.border_bottom {
  border-bottom: 1px solid #e3dad8;
}
.highlight {
  background-color: #316cc8; /*#286090 */
  color: #f9f9f9;
}
.highlight a {
  color: #f9f9f9;
}
.dropdown-menu {
  overflow: overlay !important;
}
.btn-primary:hover {
  color: #fff;
  background-color: #003993;
  border-color: #204d74;
}
.box-title-title {
  font-size: 12px;
  opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// src/views/Decentralization/DecentralizationGroup.vue